/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { getSubBrands } from "@eisinc/App/Services/SubBrandService";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { BrandCollectionModel, BrandModel } from "@insite/client-framework/Types/ApiModels";

export const DispatchBeginLoadSubBrands: any = (props: any) => {
    props.dispatch({
        type: "Data/SubBrands/BeginLoadSubBrands",
    });
};

export const RequestDataFromApi: any = async (props: any) => {
    let collection: BrandModel[] = [];

    const parameter = { ...props.parameter };
    const apiResult = await getSubBrands(parameter);

    // to avoid non-iterative object error
    collection = apiResult && apiResult.length ? [...collection, ...apiResult] : [...collection];

    props.result = collection;
};

export const DispatchCompleteLoadSubBrands: any = (props: any) => {
    props.dispatch({
        type: "Data/SubBrands/CompleteLoadSubBrands",
        collection: { brands: props.result } as BrandCollectionModel,
    });
};

export const chain = [DispatchBeginLoadSubBrands, RequestDataFromApi, DispatchCompleteLoadSubBrands];

const loadSubBrands = createHandlerChainRunner(chain, "LoadSubBrands");
export default loadSubBrands;
